import { findLibraryImage } from "@nexus/ui";
import type { DashboardComposition } from "./composition";

/** The stored header image code, under its current key or its former `headerMap` one. */
export function dashboardHeaderImage(
  composition: Pick<DashboardComposition, "headerImage" | "headerMap"> | undefined,
): string | undefined {
  return composition?.headerImage ?? composition?.headerMap;
}

/** The config with this header image (or none), stored under `headerImage` only. */
export function withDashboardHeaderImage<Config extends { composition?: DashboardComposition }>(
  config: Config,
  code: string | undefined,
): Config {
  const { headerMap: _legacy, headerImage: _current, ...composition } = config.composition ?? {};
  return {
    ...config,
    composition: code ? { ...composition, headerImage: code } : composition,
  } as Config;
}

/**
 * The header image a dashboard shows beside its title: the code of a bundled
 * library image, or nothing when it is absent or unknown. Never a path or a URL.
 */
export function resolveDashboardHeaderImage(code: string | undefined): string | undefined {
  return findLibraryImage(code)?.code;
}
